export const SAVE_SAT_USER_TYPE = 'datagathering/SAVE_SAT_USER_TYPE';
export const FETCH_SAT_USER_TYPE = 'datagathering/FETCH_SAT_USER_TYPE';
export const VALIDATE_RFC_USER_TYPE = 'datagathering/VALIDATE_RFC_USER_TYPE';
